import {
  collection,
  doc,
  getDocs,
  setDoc,
  updateDoc,
} from "firebase/firestore";
import React, { useEffect, useState } from "react";
import { db } from "../services/firebase";
import {
  Button,
  Container,
  Pagination,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  TableSortLabel,
  TextField,
} from "@mui/material";
import { formatTimestampOtp } from "../constants/Functions";
import BackdropComponent from "../components/CargaComponents/BackdropComponent";
import { useTittleContenidoStore } from "../context/tittleContenidoStore";
import { useAuthStore } from "../context/useAuthStore";
import RemoveRedEyeIcon from "@mui/icons-material/RemoveRedEye";

const OtpsNoValidados = () => {
  const { setTittleContenido }: any = useTittleContenidoStore();
  const [otps, setOtps] = useState<any[]>([]);
  const [orderDirection, setOrderDirection] = useState<"asc" | "desc">("asc");
  const [orderBy, setOrderBy] = useState<string>("phoneNumber");
  const [search, setSearch] = useState<string>(""); // Estado para el valor de búsqueda
  const [currentPage, setCurrentPage] = React.useState(1);
  const [isLoading, setIsLoading] = React.useState(false);
  const itemsPerPage = 8; // Número de otps por página
  const { Worker }: any = useAuthStore();

  // Obtener códigos OTP no validados de Firestore
  const obtenerOtps = async () => {
    try {
      const otpSnapshot = await getDocs(collection(db, "otpsRegisterSocios"));
      const otpList = otpSnapshot.docs.map((doc) => doc.data());
      setOtps(otpList);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    setTittleContenido("Codigos OTP no validados");
    obtenerOtps();
  }, []);

  // Función para manejar la ordenación
  const handleRequestSort = (property: string) => {
    const isAsc = orderBy === property && orderDirection === "asc";
    setOrderDirection(isAsc ? "desc" : "asc");
    setOrderBy(property);
  };

  // Función para ordenar los datos y filtrar por numero de celular o DNI
  const sortedOtps = otps
    .filter(
      (otp) => otp.phoneNumber.includes(search) || otp.dni.includes(search) // Filtra por el número de celular o DNI ingresado en la búsqueda
    )
    .slice()
    .sort((a: any, b: any) => {
      const aValue = a[orderBy];
      const bValue = b[orderBy];

      if (aValue < bValue) return orderDirection === "asc" ? -1 : 1;
      if (aValue > bValue) return orderDirection === "asc" ? 1 : -1;
      return 0;
    });

  // Calcular el número de páginas
  const pageCount = Math.ceil(otps.length / itemsPerPage);

  // Obtener otps de la página actual
  const displayedOtps = sortedOtps.slice(
    (currentPage - 1) * itemsPerPage,
    currentPage * itemsPerPage
  );

  // Cambiar la página
  const handlePageChange = (event: any, value: any) => {
    setCurrentPage(value);
  };

  //funcion para mostrar el otp en la celda, y registrar en una subcoleccion en firestore el usuario que lo visualizo
  const mostrarOtpVisualizar = async (phoneNumber: any, otp: any) => {
    // Solo cambia el registro de firestore agragando los datos del usuario que lo visualizo
    setIsLoading(true);
    if (otp) {
      try {
        //crear el documento en firestore con el phoneNumber
        const otpRef = doc(db, "otpsWatchedWorkers", phoneNumber);

        await setDoc(otpRef, {
          isWatched: true,
          phoneNumber: phoneNumber,
          otpNumber: otp,
          workerWatchedEmail: Worker.email,
          workerWatchedName: Worker.displayName,
          workerWatchedDate: new Date(),
        });
        await updateDoc(doc(db, "otpsRegisterSocios", phoneNumber), {
          isWatched: true,
        });
      } catch (error) {
        console.log(error);
      } finally {
        setIsLoading(false);
        obtenerOtps();
      }
    }
  };
  return (
    <Container>
      {isLoading && <BackdropComponent enabled={isLoading} />}
      <div className="d-flex justify-content-around h-100 ">
        <h2>Códigos OTP no validados</h2>
        {/* Campo de búsqueda */}
        <TextField
          label="Buscar por número de celular"
          variant="outlined"
          value={search}
          onChange={(e) => setSearch(e.target.value)}
          className="w-25"
        />
      </div>
      <br />
      <br />
      {otps.length > 0 ? (
        <div style={{ overflowX: "auto" }}>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell style={{ fontWeight: "bold" }}>DNI</TableCell>
                <TableCell style={{ fontWeight: "bold" }}>Nombre</TableCell>
                <TableCell style={{ fontWeight: "bold" }}>
                  <TableSortLabel
                    active={orderBy === "phoneNumber"}
                    direction={
                      orderBy === "phnoeNumber" ? orderDirection : "asc"
                    }
                    onClick={() => handleRequestSort("phoneNumber")}
                  >
                    Número de Celular
                  </TableSortLabel>
                </TableCell>
                <TableCell style={{ fontWeight: "bold" }}>Código OTP</TableCell>
                <TableCell style={{ fontWeight: "bold" }}>
                  <TableSortLabel
                    active={orderBy === "validUntil"}
                    direction={
                      orderBy === "validUntil" ? orderDirection : "asc"
                    }
                    onClick={() => handleRequestSort("validUntil")}
                  >
                    Fecha y hora de caducidad
                  </TableSortLabel>
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {displayedOtps.map((otp: any) => (
                <TableRow key={otp.otp}>
                  <TableCell>{otp.dni}</TableCell>
                  <TableCell>{otp.nombreSocio}</TableCell>
                  <TableCell>{otp.phoneNumber}</TableCell>
                  <TableCell>
                    {/* Muestra el OTP si está en la lista de visualizados */}
                    {otp.isWatched ? (
                      otp.otp // Muestra el OTP si ya ha sido visualizado
                    ) : (
                      <Button
                        variant="contained"
                        color="success"
                        onClick={() =>
                          mostrarOtpVisualizar(otp.phoneNumber, otp.otp)
                        }
                      >
                        <RemoveRedEyeIcon className="me-2" />
                        Visualizar
                      </Button>
                    )}
                  </TableCell>
                  <TableCell>{formatTimestampOtp(otp.validUntil)}</TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </div>
      ) : (
        <BackdropComponent enabled={true} />
      )}

      {/* Paginación */}
      <Stack spacing={2} alignItems="center" marginY={2}>
        <Pagination
          count={pageCount}
          page={currentPage}
          onChange={handlePageChange}
          color="primary"
        />
      </Stack>
    </Container>
  );
};

export default OtpsNoValidados;
